import { QuoteDetail } from '@quorum/models/xs-resource';
import { QuoteDetailQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export enum QuoteLinesEntityActionTypes {
  GetQuoteLinesFromServer = '[Fixed Operations] Get Quote Lines From Server',
  GetQuoteLinesFromServerError = '[Fixed Operations] Get Quote Lines From Server Error',
  GetQuoteLinesFromServerSuccess = '[Fixed Operations] Get Quote Lines From Server Success',
  UpdateQuoteLineOnServer = '[Fixed Operations] Update Quote Line From Server',
  UpdateQuoteLineOnServerError = '[Fixed Operations] Update Quote Line From Server Error',
  UpdateQuoteLineOnServerSuccess = '[Fixed Operations] Update Quote Line From Server Success',
  CreateQuoteLineOnServer = '[Fixed Operations] Create Quote Line From Server',
  CreateQuoteLineOnServerError = '[Fixed Operations] Create Quote Line From Server Error',
  CreateQuoteLineOnServerSuccess = '[Fixed Operations] Create Quote Line From Server Success',
  DeleteQuoteLineFromServer = '[Fixed Operations] Delete Quote Line From Server',
  DeleteQuoteLineFromServerError = '[Fixed Operations] Delete Quote Line From Server Error',
  DeleteQuoteLineFromServerSuccess = '[Fixed Operations] Delete Quote Line From Server Success',
  UpdateDeclinedReasonForQuoteLineOnServer = '[Fixed Operations] Update Declined Reason For Quote Line On Server',
  UpdateDeclinedReasonForQuoteLineOnServerError = '[Fixed Operations] Update Declined Reason For Quote Line On Server Error',
  UpdateDeclinedReasonForQuoteLineOnServerSuccess = '[Fixed Operations] Update Declined Reason For Quote Line On Server Success',
}

//#region message-types
export class GetQuoteLinesFromServer implements Action {
  readonly type = QuoteLinesEntityActionTypes.GetQuoteLinesFromServer;
  constructor(public payload: QuoteDetailQueryParameters) {}
}
export class GetQuoteLinesFromServerError implements Action {
  readonly type = QuoteLinesEntityActionTypes.GetQuoteLinesFromServerError;
  constructor(public payload: any) {}
}
export class GetQuoteLinesFromServerSuccess implements Action {
  readonly type = QuoteLinesEntityActionTypes.GetQuoteLinesFromServerSuccess;
  constructor(public payload: QuoteDetail[]) {}
}

export class UpdateQuoteLineOnServer implements Action {
  readonly type = QuoteLinesEntityActionTypes.UpdateQuoteLineOnServer;
  constructor(public payload: QuoteDetail) {}
}
export class UpdateQuoteLineOnServerError implements Action {
  readonly type = QuoteLinesEntityActionTypes.UpdateQuoteLineOnServerError;
  constructor(public payload: any) {}
}
export class UpdateQuoteLineOnServerSuccess implements Action {
  readonly type = QuoteLinesEntityActionTypes.UpdateQuoteLineOnServerSuccess;
  constructor(public payload: QuoteDetail) {}
}

export class UpdateDeclinedReasonForQuoteLineOnServer implements Action {
  readonly type = QuoteLinesEntityActionTypes.UpdateDeclinedReasonForQuoteLineOnServer;
  constructor(public payload: QuoteDetail) {}
}
export class UpdateDeclinedReasonForQuoteLineOnServerError implements Action {
  readonly type = QuoteLinesEntityActionTypes.UpdateDeclinedReasonForQuoteLineOnServerError;
  constructor(public payload: { message: string; error: any }) {}
}
export class UpdateDeclinedReasonForQuoteLineOnServerSuccess implements Action {
  readonly type = QuoteLinesEntityActionTypes.UpdateDeclinedReasonForQuoteLineOnServerSuccess;
  constructor(public payload: QuoteDetail) {}
}

export class CreateQuoteLineOnServer implements Action {
  readonly type = QuoteLinesEntityActionTypes.CreateQuoteLineOnServer;
  constructor(public payload: { quoteLine: QuoteDetail; queryParams: QuoteDetailQueryParameters }) {}
}
export class CreateQuoteLineOnServerError implements Action {
  readonly type = QuoteLinesEntityActionTypes.CreateQuoteLineOnServerError;
  constructor(public payload: any) {}
}
export class CreateQuoteLineOnServerSuccess implements Action {
  readonly type = QuoteLinesEntityActionTypes.CreateQuoteLineOnServerSuccess;
  constructor(public payload: { quoteLine: QuoteDetail; previousValue: QuoteDetail }) {}
}

export class DeleteQuoteLineFromServer implements Action {
  readonly type = QuoteLinesEntityActionTypes.DeleteQuoteLineFromServer;
  constructor(public payload: { quoteLine: QuoteDetail }) {}
}
export class DeleteQuoteLineFromServerError implements Action {
  readonly type = QuoteLinesEntityActionTypes.DeleteQuoteLineFromServerError;
  constructor(public payload: { quoteLine: QuoteDetail; error: any }) {}
}
export class DeleteQuoteLineFromServerSuccess implements Action {
  readonly type = QuoteLinesEntityActionTypes.DeleteQuoteLineFromServerSuccess;
  constructor(public payload: QuoteDetail) {}
}
//#endregion

export type QuoteLinesEntityAction =
  | GetQuoteLinesFromServer
  | GetQuoteLinesFromServerError
  | GetQuoteLinesFromServerSuccess
  | UpdateQuoteLineOnServer
  | UpdateQuoteLineOnServerError
  | UpdateQuoteLineOnServerSuccess
  | UpdateDeclinedReasonForQuoteLineOnServer
  | UpdateDeclinedReasonForQuoteLineOnServerError
  | UpdateDeclinedReasonForQuoteLineOnServerSuccess
  | CreateQuoteLineOnServer
  | CreateQuoteLineOnServerError
  | CreateQuoteLineOnServerSuccess
  | DeleteQuoteLineFromServer
  | DeleteQuoteLineFromServerError
  | DeleteQuoteLineFromServerSuccess;

export const fromQuoteLinesEntityActions = {
  GetQuoteLinesFromServer,
  GetQuoteLinesFromServerError,
  GetQuoteLinesFromServerSuccess,
  UpdateQuoteLineOnServer,
  UpdateQuoteLineOnServerError,
  UpdateQuoteLineOnServerSuccess,
  UpdateDeclinedReasonForQuoteLineOnServer,
  UpdateDeclinedReasonForQuoteLineOnServerError,
  UpdateDeclinedReasonForQuoteLineOnServerSuccess,
  CreateQuoteLineOnServer,
  CreateQuoteLineOnServerError,
  CreateQuoteLineOnServerSuccess,
  DeleteQuoteLineFromServer,
  DeleteQuoteLineFromServerError,
  DeleteQuoteLineFromServerSuccess,
};
